module.exports = __webpack_public_path__ + "assets/default-alt.741c03e6.svg";